import { render, staticRenderFns } from "./DefTextarea.vue?vue&type=template&id=426f56a2&scoped=true&"
import script from "./DefTextarea.vue?vue&type=script&lang=js&"
export * from "./DefTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DefTextarea.vue?vue&type=style&index=0&id=426f56a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426f56a2",
  null
  
)

export default component.exports